import axios from "lib/axios";

export const archiveStructureApi = async (building_id, id) => {
  return await axios.delete(`/api/buildings/${building_id}/building_structures/${id}`);
};
